<script setup>
import { ref } from "vue";
import useActionButtonsCommon from "@/composables/ActionButtonsCommon";

const { store, loading, _error } = useActionButtonsCommon();

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(["update:modelValue"]);

const selectedFile = ref(null);
const fileName = ref("");

const handleFileChange = (event) => {
  const file = event.target.files[0];
  if (file) {
    selectedFile.value = file;
    fileName.value = file.name;
  }
};

const browseFile = () => {
  document.getElementById("deviceFile").click();
};

const uploadDevices = async () => {
  if (selectedFile.value) {
    try {
      loading.value = true;

      await store.dispatch("devices/uploadBulkDevices", selectedFile.value);

      loading.value = false;

      closeModal();
    } catch (error) {
      loading.value = false;
      _error.value =
        error?.message || error?.msg || "Failed to updload devices";
    }
  }
};

const closeModal = () => {
  emit("update:modelValue", false);
  selectedFile.value = null;
  fileName.value = "";
};
</script>

<template>
  <div v-if="modelValue">
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
      <div class="modal-backdrop fade show" @click="closeModal"></div>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Upload Bulk Devices</h4>
            <button type="button" class="close" @click="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Browse Devices CSV File</label>
                  <div class="input-group">
                    <div class="custom-file">
                      <input
                        type="file"
                        class="custom-file-input"
                        id="deviceFile"
                        @change="handleFileChange"
                        accept=".csv"
                      />
                      <label class="custom-file-label" for="deviceFile">
                        {{ fileName || "Choose file" }}
                      </label>
                    </div>
                    <div class="input-group-append">
                      <button
                        class="btn btn-default"
                        type="button"
                        @click="browseFile"
                      >
                        Browse
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>Download Devices Template</label>
                  <div>
                    <a
                      href="https://rest.tagmarshal.golf/public/template.csv"
                      class="text-primary"
                    >
                      Click here to download.
                    </a>
                  </div>
                </div>
              </div>
              <p v-if="_error" class="text-danger">
                {{ _error }}
              </p>
            </div>
          </div>

          <div class="modal-footer justify-content-end">
            <button type="button" class="btn btn-danger" @click="closeModal">
              CLOSE
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="uploadDevices"
              :disabled="!selectedFile"
            >
              UPLOAD DEVICE(S)
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "@/styles/modal.css";

.custom-file-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.custom-file-label::after {
  content: none !important;
}
</style>
